export default "__VITE_ASSET__BpSwTS_0__"